export default {
  CATEGORIES: (state) => state.categories,
  GET_CATEGORIES_DATA: (state) => state.categories,
};
